import { React, useState, useEffect } from "react";
import List from "@mui/material/List";

import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import api from "../../api";
import LikeComent from "../../elements/like_coment/like_coment";

const L = styled(List)(({ theme }) => ({
  backgroundColor: theme.color.banner,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
  width: "100%",
  maxWidth: 700,
}));

const BodyComent = ({ coment, token, disable }) => {
  const [dataComent, setDataComent] = useState(coment);
  const noFoto = "/static/img/avatar/nofoto.jpg";
  const [isDisabled, setDisabled] = useState(false);
  function getCookie(name) {
    if (!document.cookie) return null;
    const xsrfCookies = document.cookie
      .split(";")
      .map((c) => c.trim())
      .filter((c) => c.startsWith(name + "="));
    if (xsrfCookies.length === 0) return null;
    return decodeURIComponent(xsrfCookies.toString().split("="));
  }
  const csrfToken = getCookie("csrftoken");
  // const delComent = (e) => {
  //   api.delComent(e, token, csrfToken);
  // };
  const delComent = (e) => {
    setDisabled(true);
    // console.log("SDFFFFFFFFFFFF");
    api.delComent(e, token, csrfToken).then((response) => {
      if (response.status === 200) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    });
  };

  useEffect(() => {
    setDataComent(coment);
    setDisabled(disable);
  }, [coment, disable]);

  return (
    <L>
      {dataComent
        ? dataComent.map((e) => (
            <>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar
                    alt="Remy Sharp"
                    src={
                      e.fk_user_coment["image"]
                        ? e.fk_user_coment["image"]
                        : noFoto
                    }
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2">
                      <strong>
                        {e.fk_user_coment["first_name"] +
                          " " +
                          e.fk_user_coment["last_name"]}
                      </strong>
                    </Typography>
                  }
                  secondary={
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{ color: "text.primary", display: "inline" }}
                    >
                      {e.coment_field}
                      {e.fk_user_coment["key"] === token ? (
                        <IconButton
                          disabled={isDisabled}
                          aria-label="удалить"
                          onClick={() => delComent(e.id)}
                          sx={(theme) => ({
                            position: "absolute",
                            right: 2,
                            top: 10,
                            color: theme.palette.grey[500],
                          })}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      ) : (
                        ""
                      )}

                      {/* <IconButton
                    aria-label="класс"
                    // onClick={() => delComent(e.id)}
                    sx={(theme) => ({
                      position: "absolute",
                      right: -2,
                      top: 20,
                      "&:hover": {
                        backgroundColor: "white",
                        color: "error.main", // Изменение цвета иконки при наведении
                      },
                      "&:active": {
                        color: "white", // Изменение цвета иконки при нажатии
                      },
                    })}
                  >
                    <LikeComent />
                  </IconButton> */}
                    </Typography>
                  }
                />
              </ListItem>

              {/* <Divider variant="inset" component="li" /> */}
              <Stack direction="row" spacing={2} justifyContent="space-around">
                <Typography
                  component="span"
                  variant="caption"
                  sx={{
                    color: "text.primary",
                  }}
                >
                  {e.created_time}
                </Typography>
                <LikeComent data={e} />
              </Stack>
            </>
          ))
        : ""}
    </L>
  );
};

export default BodyComent;
